import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { setWasPatientImmobilized } from '../store/wasPatientImmobilized.actions'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { wasPatientImmobilizedPrAssess, wasPatientImmobilizedPrNabc } from '../store/wasPatientImmobilized.reducers'
import { _featureRefKey } from '../../store/neuro.reducers'

export function* getWasPatientImmobilized(pcrDoc: IPcr) {
  let wasPatientImmobilizedPrNabcData = {},
    wasPatientImmobilizedPrAssessData = {}

  if (pcrDoc.prNabc) {
    const wasPatientImmobilizedPrNeuroKeys: any = Object.keys(wasPatientImmobilizedPrNabc)
    wasPatientImmobilizedPrNabcData = getSelectedDataFromObject(pcrDoc.prNabc, wasPatientImmobilizedPrNeuroKeys)
  }
  if (pcrDoc.prAssess) {
    const prAssessData = pcrDoc.prAssess.find((prAssObj) => prAssObj._featureRefKey === _featureRefKey)
    const wasPatientImmobilizedPrAssessKeys: any = Object.keys(wasPatientImmobilizedPrAssess)
    wasPatientImmobilizedPrAssessData = getSelectedDataFromObject(prAssessData, wasPatientImmobilizedPrAssessKeys)
  }

  if (
    Object.keys(wasPatientImmobilizedPrNabcData).length !== 0 ||
    Object.keys(wasPatientImmobilizedPrAssessData).length !== 0
  ) {
    yield put(setWasPatientImmobilized({ ...wasPatientImmobilizedPrNabcData, ...wasPatientImmobilizedPrAssessData }))
  }
}
